/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2019-08-13 16:24:24
 * @LastEditors: cxt
 */
import utils from 'utils';
import { store } from 'src/redux/store';

export default {
  getAddress(id) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/orders/${id}/order_address`
    );
  },
  getRegions() {
    return this.http('api', 'get', 'shop-interface/v1/shipment/all_area');
  },
  modifyAddress(id, params) {
    return this.http(
      'Lottery',
      'post',
      `/api/v1/orders/${id}/change_address`,
      params
    );
  },
  getShopReduction(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/labels/patch_goods',
      data
    );
  },
  getShopClassifyReduction(id) {
    return this.http(
      'api',
      'get',
      `/shop-interface/v1/promotion/goods?prom_id=${id}`
    );
  },
  getShopRank(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/order_ranks',
      data
    );
  },
  getNewCustomMes(id) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/home_components/${id}/newbie`
    );
  },
  getNewCustomCoupon(data) {
    return this.http(
      'Lottery',
      'post',
      '/api/v1/user_get_records',
      data
    );
  },
  getInvoiceOrderList() {
    return this.http(
      'api',
      'get',
      '/shop-interface/v1/invoice/order-list'
    );
  },
  getInvoiceList(data) {
    return this.http(
      'api',
      'get',
      '/shop-interface/v1/invoice/list',
      data
    );
  },
  postInvoiceMes(data) {
    return this.http(
      'api',
      'post',
      '/shop-interface/v1/invoice/create',
      data
    );
  },
  getInvoiceMes(id) {
    return this.http(
      'api',
      'get',
      '/shop-interface/v1/invoice/info',
      {
        id
      }
    );
  },
  postInvoiceNotice(id) {
    return this.http(
      'Lottery',
      'post',
      `/api/v1/invoices/${id}/send_message`
    );
  },
  getLastInvoiceMes() {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/invoices/invoice_info'
    );
  },
  getCustomizeReport(data) {
    return this.http(
      'SEAFARER',
      'get',
      '/api/v1/evaluation_report',
      data
    );
  },
  getCustomizeGoods(data) {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/virtual_goods',
      data
    );
  },
  getDefaultAddress() {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/orders/previous_address.json'
    );
  },
  getPreviewOrder(data) {
    return this.http(
      'Lottery',
      'post',
      '/api/v3/orders/preview',
      data
    );
  },
  goAddOrder(data) {
    return this.http(
      'Lottery',
      'post',
      '/api/v3/orders',
      data
    );
  },
  goReferMes(data) {
    return this.http(
      'League',
      'get',
      '/api/pub/recommend_tasks/show',
      data
    );
  },
  postReferMes(data, id) {
    return this.http(
      'League',
      'post',
      `/api/pub/recommend_records/create?id=${id}`,
      data,
    );
  },
  getShopHot(data) {
    return this.http(
      'api',
      'get',
      '/shop-interface/v1/home/hot_sale_board',
      data,
    );
  },
  getShopFollowList(id, data) {
    return this.http(
      'Lottery',
      'get',
      `/api/v1/home_components/${id}/follow`,
      data,
    );
  },
  getShopChooseSetting(id) {
    const { token } = store.getState();
    const headers = {
      token,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'App-Key': utils.getAppKey()
    };
    return this.http(
      'api',
      'get',
      `/shop-interface/v1/promotion/circulate_goods?prom_id=${id}`,
      {},
      headers
    );
  },
  addGood(data) {
    const { token } = store.getState();
    const headers = {
      token,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'App-Key': utils.getAppKey()
    };
    return this.http(
      'api',
      'post',
      '/shop-interface/api/v1/order/addCart',
      data,
      headers
    );
  },
  updateGood(data) {
    const { token } = store.getState();
    const headers = {
      token,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'App-Key': utils.getAppKey()
    };
    return this.http(
      'api',
      'post',
      '/shop-interface/api/v1/order/editCartItem',
      data,
      headers
    );
  },
  removeGood(data) {
    const { token } = store.getState();
    const headers = {
      token,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'App-Key': utils.getAppKey()
    };
    return this.http(
      'api',
      'post',
      '/shop-interface/api/v1/order/delCartItem',
      data,
      headers
    );
  }
};
